import React from 'react';
import { useAppDispatch } from '../app/hooks';

import { showGlobalYesNoDialog } from '../features/globalYesNoDialogSlice';

import { formatDialogContent } from './dialogHelpers';

/**
 * useGlobalYesNoDialog - provides generic function for displaying Yes/No dialog
 *
 * @export
 * @return {*} 
 */
 export default function useGlobalYesNoDialog() {
  const dispatch = useAppDispatch();

  /**
   * showYesNoDialog - awaitable Promise to show global yes/no dialog. Result is true for Yes and false for No
   *
   * @param {(string|null)} [top=null] - use to override top position on the screen (middle of the screen by default)
   * @return {*} 
   */
   function showYesNoDialog(contentParam:string|React.ReactNode, invert?:boolean, focusindex?:number, addor?:boolean, type:'info'|'warning'='info') {
    return new Promise<boolean>(resolve => {

      dispatch(showGlobalYesNoDialog({
        content: formatDialogContent(contentParam),
        resolve,
        invert:invert??false,
        focusindex:focusindex??0,
        addor:addor??false,
        type,
      }));
    })
  }

  return [showYesNoDialog];
}